/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Image, Text, Pressable } from '@components/atoms'
import { Footer, Seo } from '@components/systems'
import { buildOnlineStoreJsonLd } from '@utils'
import amp2_1Img from '@public/images/pages/home/amp2_1.gif'
import amp2_2Img from '@public/images/pages/home/amp2_2.jpg'
import kedem1Img from '@public/images/pages/home/kedem1.jpg'
import kedem2Img from '@public/images/pages/home/kedem2.jpg'

import { useNavigate } from 'react-router-dom'
import { grey, lime } from '@mui/material/colors'

const HomePage = () => {
	// hook
	const navigate = useNavigate()

	const jsonLd = React.useMemo(() => buildOnlineStoreJsonLd(), [])

	return (
		<View css={style}>
			<Seo jsonLd={jsonLd} />

			{/* <View className="eventView">
				<Text className="eventTitle" category="h1">
					📢 Pre-Order Closing Soon!
				</Text>
				<ul className="eventUl">
					<li className="eventLi">⏰ Finish in May</li>
					<li className="eventLi">🚀 Shipping starts in July</li>
					<li className="eventLi">🚛 Free shipping – no extra cost!</li>
				</ul>

				<Text className="eventPrice">💥 Special Prices:</Text>
				<p className="eventPriceUnit">
					Kedem 6: <span className="eventNormalPrice">$407</span> ⮕{' '}
					<span className="eventDiscountedPrice">$369</span>
				</p>
				<p className="eventPriceUnit">
					Kedem 4: <span className="eventNormalPrice">$341</span> ⮕{' '}
					<span className="eventDiscountedPrice">$305</span>
				</p>
			</View> */}
			<View className="mainView">
				<View className="mainBgView">
					<Image src={amp2_1Img} className="mainImage" />
				</View>
			</View>

			<View className="middleBannerView">
				<Text category="h1" className="middleBannerTitle">
					ELEVATE
				</Text>
				<Text category="h1" className="middleBannerTitle thick">
					YOUR
				</Text>
				<Text category="h1" className="middleBannerTitle thick">
					VALUE
				</Text>
			</View>

			<View className="rts-View">
				<View className="rts-TextOuterView">
					<View className="rts-TextView">
						<View className="rts-TitleView newline">
							<Text category="h3" className="rts-Title title1">
								AirMIDI POG2:
							</Text>{' '}
							<br />
							<Text category="h3" className="rts-Title title2">
								Go Wireless with KEDEM
							</Text>
						</View>

						<View className="">
							<Text
								category="s1"
								className="rts-Title title2"
								css={{ textAlign: 'left' }}
							>
								Step on stage. Control every preset.
							</Text>
							<Text
								category="s1"
								className="rts-Title title2"
								css={{ textAlign: 'left' }}
							>
								POG2 + KEDEM = full wireless MIDI freedom.
							</Text>
						</View>
					</View>
				</View>
				<View className="rts-BgView">
					<Pressable onClick={() => navigate('/shop/amp2')}>
						<Image src={amp2_2Img} className="rts-BgImage" />
					</Pressable>
				</View>
			</View>

			<View className="lts-View">
				<View className="lts-BgView">
					<Pressable onClick={() => navigate('/shop')}>
						<Image src={kedem1Img} className="lts-BgImage" />
					</Pressable>
				</View>
				<View className="lts-TextOuterView">
					<View>
						<View className="lts-TitleOuterView">
							<View className="lts-TitleView">
								<Text category="h3" className="lts-Title title1">
									NEW
								</Text>
								<Text category="h3" className="lts-Title title2">
									UNITY
								</Text>
							</View>
						</View>
						<View className="lts-SubtitleView">
							<Text className="lts-Subtitle" category="h6">
								The Beginning of a New Connection
							</Text>
							<Text className="lts-Subtitle" category="p1">
								With the Kedem series MIDI controllers,
							</Text>
							<Text className="lts-Subtitle" category="p1">
								your gear is near, the link is clear.
							</Text>
							<Text className="lts-Subtitle" category="p1">
								Unleash boundless creativity and control,
							</Text>
							<Text className="lts-Subtitle" category="p1">
								{"elevate your soul and rock 'n' roll."}
							</Text>
						</View>
					</View>
				</View>
			</View>

			<View className="middleBannerView">
				<Text category="h1" className="middleBannerTitle">
					A
				</Text>
				<Text category="h1" className="middleBannerTitle thick">
					New Unity
				</Text>
				<Text category="h1" className="middleBannerTitle">
					for
				</Text>
				<Text category="h1" className="middleBannerTitle">
					Hyper-Reality
				</Text>
			</View>

			<View className="rts-View">
				<View className="rts-TextOuterView">
					<View className="rts-TextView">
						<View className="rts-TitleView">
							<Text category="h3" className="rts-Title title1">
								NEW
							</Text>
							<Text category="h3" className="rts-Title title2">
								UNITY
							</Text>
						</View>

						<View className="">
							<Text
								category="s1"
								className="rts-Title title2"
								css={{ textAlign: 'left' }}
							>
								We make pedals that are endlessly explorable
							</Text>
							<Text
								category="s1"
								className="rts-Title title2"
								css={{ textAlign: 'left' }}
							>
								and make magic the first time you plug them in.
							</Text>
						</View>
					</View>
				</View>
				<View className="rts-BgView">
					<Pressable onClick={() => navigate('/shop')}>
						<Image src={kedem2Img} className="rts-BgImage" />
					</Pressable>
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default HomePage

const style = css({
	position: 'relative',
	width: '100%',

	'.eventView': {
		width: '100%',
		padding: '4rem 0 4rem 4rem',
		background: lime['A200'],
		color: grey[900],
		textAlign: 'left',

		'.eventTitle': {
			fontSize: '100px',
			marginTop: '0',
			marginBottom: '0',
		},

		'.eventUl': {
			'.eventLi': {
				fontSize: '50px',
				fontWeight: '800',
				marginLeft: '4rem',
				marginBottom: '1rem',
			},
		},

		'.eventPrice': {
			fontSize: '70px',
			marginTop: '5rem',
			marginBottom: '1rem',
		},

		'.eventPriceUnit': {
			marginLeft: '5rem',
			marginTop: '0',
			marginBottom: '0',
			fontSize: '50px',
			fontWeight: '800',

			'.eventNormalPrice': {
				marginLeft: '3rem',
				marginRight: '3rem',
				textDecoration: 'line-through',
				fontSize: '30px',
				fontWeight: '300',
			},
			'.eventDiscountedPrice': {
				marginLeft: '3rem',
				fontSize: '50px',
			},
		},
	},

	'.mainView': {
		display: 'flex',
		width: '100%',
		borderBottom: '1px solid',
		borderColor: grey[900],

		'.mainBgView': {
			position: 'relative',
			display: 'flex',
			width: '100%',
			height: 'fit-content',
			overflow: 'hidden',

			'.mainImage': {
				width: '100%',
				height: 'auto',
				margin: 'auto',
				left: 0,
				right: 0,
				bottom: 0,
			},
		},
	},

	'.lts-View': {
		display: 'flex',
		width: '100%',
		borderBottom: '1px solid',
		borderColor: grey[900],

		'.lts-BgView': {
			position: 'relative',
			display: 'flex',
			width: '65%',
			height: '40vw',
			overflow: 'hidden',

			'.lts-BgImage': {
				position: 'absolute',
				bottom: 0,
				width: 'auto',
				height: '100%',
			},
		},
		'.lts-TextOuterView': {
			position: 'relative',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			width: '35%',

			'.lts-TitleOuterView': {
				width: '12rem',
				margin: 'auto',
				marginTop: '3rem',
				padding: '1rem',
				border: '1px solid',

				'.lts-TitleView': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '100%',
					height: '100%',

					'.lts-Title': {
						margin: 0,

						'&.title1': {
							marginRight: '0.5rem',
							fontWeight: '100',
						},
					},
				},
			},
			'.lts-SubtitleView': {
				'.lts-Subtitle': {},
			},
		},
	},

	'.middleBannerView': {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		height: '10rem',
		width: '100%',
		padding: '2rem',
		background: grey[900],
		color: 'white',

		'.middleBannerTitle': {
			marginRight: '0.5rem',
			fontWeight: '100',

			'&.thick': {
				fontWeight: '800',
			},
		},
	},

	'.rts-View': {
		display: 'flex',
		width: '100%',
		borderBottom: '1px solid',
		borderColor: grey[900],

		'.rts-BgView': {
			position: 'relative',
			display: 'flex',
			width: '65%',
			height: '40vw',
			overflow: 'hidden',

			'.rts-BgImage': {
				position: 'absolute',
				bottom: 0,
				width: 'auto',
				height: '100%',
			},
		},

		'.rts-TextOuterView': {
			position: 'relative',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			width: '35%',

			'.rts-TextView': {
				padding: '2rem',

				'.rts-TitleView': {
					display: 'flex',
					justifyContent: 'flex-start',
					alignItems: 'center',
					width: '100%',
					height: '100%',

					'.rts-Title': {
						'&.title1': {
							marginRight: '0.5rem',
							fontWeight: '100',
						},
					},

					'&.newline': {
						display: 'block',
						marginBottom: '2rem',

						'.rts-Title': {
							marginTop: 0,
							marginBottom: 0,
							textAlign: 'left',

							'&.title2': {
								marginTop: '-1rem',
							},
						},
					},
				},
			},
		},
	},

	'@media (max-width: 1380px)': {
		'.eventView': {
			'.eventTitle': {
				fontSize: '80px',
			},
		},
	},

	'@media (max-width: 1150px)': {
		'.eventView': {
			'.eventTitle': {
				fontSize: '48px',
			},

			'.eventUl': {
				'.eventLi': {
					fontSize: '30px',
					fontWeight: '800',
					marginLeft: '4rem',
					marginBottom: '0.2rem',
				},
			},

			'.eventPrice': {
				fontSize: '48px',
				marginTop: '3rem',
				marginBottom: '1rem',
			},

			'.eventPriceUnit': {
				marginLeft: '5rem',
				marginTop: '0',
				marginBottom: '0',
				fontSize: '30px',
				fontWeight: '800',

				'.eventNormalPrice': {
					marginLeft: '1rem',
					marginRight: '1rem',
					textDecoration: 'line-through',
					fontSize: '30px',
					fontWeight: '300',
				},
				'.eventDiscountedPrice': {
					marginLeft: '1rem',
					fontSize: '30px',
				},
			},
		},
	},

	'@media (max-width: 750px)': {
		'.eventView': {
			'.eventTitle': {
				fontSize: '40px',
			},

			'.eventUl': {
				'.eventLi': {
					fontSize: '25px',
					fontWeight: '800',
					marginLeft: '2rem',
					marginBottom: '0.2rem',
				},
			},

			'.eventPrice': {
				fontSize: '40px',
				marginTop: '3rem',
				marginBottom: '1rem',
			},

			'.eventPriceUnit': {
				marginLeft: '3rem',
				marginTop: '0',
				marginBottom: '0',
				fontSize: '25px',
				fontWeight: '800',

				'.eventNormalPrice': {
					marginLeft: '1rem',
					marginRight: '1rem',
					textDecoration: 'line-through',
					fontSize: '20px',
					fontWeight: '300',
				},
				'.eventDiscountedPrice': {
					marginLeft: '1rem',
					fontSize: '25px',
				},
			},
		},

		'.lts-View': {
			display: 'block',
			'.lts-BgView': {
				width: '100%',
				height: 'fit-content',
				'.lts-BgImage': {
					width: '100%',
					height: 'auto',
					position: 'relative',
				},
			},

			'.lts-TextOuterView': {
				height: '20rem',
				width: '100%',
			},
		},

		'.rts-View': {
			display: 'block',
			'.rts-BgView': {
				width: '100%',
				height: 'fit-content',
				'.rts-BgImage': {
					width: '100%',
					height: 'auto',
					position: 'relative',
				},
			},

			'.rts-TextOuterView': {
				height: '20rem',
				width: '100%',
			},
		},
	},

	'@media (max-width: 600px)': {
		'.eventView': {
			padding: '2rem 0 2rem 2rem',

			'.eventTitle': {
				fontSize: '30px',
			},

			'.eventUl': {
				'.eventLi': {
					fontSize: '20px',
					fontWeight: '800',
					marginLeft: '1rem',
					marginBottom: '0.2rem',
				},
			},

			'.eventPrice': {
				fontSize: '30px',
				marginTop: '2rem',
				marginBottom: '1rem',
			},

			'.eventPriceUnit': {
				marginLeft: '3rem',
				marginTop: '0',
				marginBottom: '0',
				fontSize: '20px',
				fontWeight: '800',

				'.eventNormalPrice': {
					marginLeft: '1rem',
					marginRight: '1rem',
					textDecoration: 'line-through',
					fontSize: '15px',
					fontWeight: '300',
				},
				'.eventDiscountedPrice': {
					marginLeft: '1rem',
					fontSize: '20px',
				},
			},
		},
	},

	'@media (max-width: 450px)': {
		'.eventView': {
			padding: '2rem 0 2rem 2rem',

			'.eventTitle': {
				fontSize: '24px',
			},

			'.eventUl': {
				'.eventLi': {
					fontSize: '15px',
					fontWeight: '800',
					marginLeft: '1rem',
					marginBottom: '0.2rem',
				},
			},

			'.eventPrice': {
				fontSize: '24px',
				marginTop: '2rem',
				marginBottom: '1rem',
			},

			'.eventPriceUnit': {
				marginLeft: '3rem',
				marginTop: '0',
				marginBottom: '0',
				fontSize: '15px',
				fontWeight: '800',

				'.eventNormalPrice': {
					marginLeft: '1rem',
					marginRight: '1rem',
					textDecoration: 'line-through',
					fontSize: '12px',
					fontWeight: '300',
				},
				'.eventDiscountedPrice': {
					marginLeft: '1rem',
					fontSize: '15px',
				},
			},
		},
	},
})
